// extracted by mini-css-extract-plugin
module.exports = {"newMessageInputField":"ChatNewMessage_newMessageInputField__2ssg4","newMessage":"ChatNewMessage_newMessage__1qBlk","characterCounter":"ChatNewMessage_characterCounter__KoHQ3"};